var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _c("div", { staticClass: "layout__header" }, [
        _c("div", { staticClass: "layout__title" }, [
          _c("h3", [
            _vm._v("Retención " + _vm._s(_vm.form.numero_comprobante))
          ]),
          _vm._v(" "),
          _c("label", [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.anulado === "S",
                    expression: "anulado === 'S'"
                  }
                ],
                staticClass: "noti-danger"
              },
              [_c("strong", [_vm._v("ANULADO")])]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.estado === "A" && _vm.anulado === "N",
                    expression: "estado === 'A' && anulado === 'N'"
                  }
                ],
                staticClass: "noti-success"
              },
              [_c("strong", [_vm._v("AUTORIZADO")])]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.estado === "N" && _vm.anulado === "N",
                    expression: "estado === 'N' && anulado === 'N'"
                  }
                ],
                staticClass: "noti-secondary"
              },
              [_c("strong", [_vm._v("NUEVO")])]
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "layout__controls" },
          [
            _c(
              "button",
              {
                staticClass: "btn-info btn--bigger",
                attrs: {
                  disabled:
                    !_vm.permiteAnularRetencion && !_vm.permiteEditarRetencion,
                  type: "button"
                },
                on: { click: _vm.consultarComprobantes }
              },
              [
                _c("i", { staticClass: "fa fa-search" }),
                _vm._v(" "),
                _c("span", [_vm._v("Buscar comprobantes")])
              ]
            ),
            _vm._v(" "),
            _c(
              "modal",
              {
                attrs: {
                  width: "85%",
                  height: "auto",
                  scrollable: "",
                  name: "listaComprobantes"
                }
              },
              [
                _c("lista-comprobantes-compra", {
                  attrs: { tipoComprobante: _vm.tipoComprobante },
                  on: { selected: _vm.selectedComprobante }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "layout__main" }, [
        _c("div", { staticClass: "layout__main-form" }, [
          _c("div", { staticClass: "card" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "card__content" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                  _c("div", { staticClass: "form-inline" }, [
                    _c("label", { attrs: { for: "manual" } }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.tipo,
                            expression: "form.tipo"
                          }
                        ],
                        attrs: {
                          disabled: !_vm.editable || _vm.form.mybillbot,
                          value: "M",
                          type: "radio",
                          id: "manual"
                        },
                        domProps: { checked: _vm._q(_vm.form.tipo, "M") },
                        on: {
                          change: function($event) {
                            return _vm.$set(_vm.form, "tipo", "M")
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v("Manual")])
                    ]),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "electronico" } }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.tipo,
                            expression: "form.tipo"
                          }
                        ],
                        attrs: {
                          disabled: !_vm.editable || _vm.form.mybillbot,
                          value: "E",
                          type: "radio",
                          id: "electronico"
                        },
                        domProps: { checked: _vm._q(_vm.form.tipo, "E") },
                        on: {
                          change: function($event) {
                            return _vm.$set(_vm.form, "tipo", "E")
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v("Electrónico")])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                  _c("div", { staticClass: "form-field" }, [
                    _c("label", { attrs: { for: "mybillbot" } }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.mybillbot,
                            expression: "form.mybillbot"
                          }
                        ],
                        attrs: {
                          disabled: "",
                          type: "checkbox",
                          id: "mybillbot"
                        },
                        domProps: {
                          checked: Array.isArray(_vm.form.mybillbot)
                            ? _vm._i(_vm.form.mybillbot, null) > -1
                            : _vm.form.mybillbot
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.form.mybillbot,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.form,
                                    "mybillbot",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.form,
                                    "mybillbot",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(_vm.form, "mybillbot", $$c)
                            }
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v("Importado por MyBillBot")])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                  _c("div", { staticClass: "form-field" }, [
                    _c("div", { staticClass: "form-field" }, [
                      _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _c(
                            "input-field",
                            {
                              directives: [
                                {
                                  name: "mask",
                                  rawName: "v-mask",
                                  value: "###-###-#########",
                                  expression: "'###-###-#########'"
                                }
                              ],
                              attrs: {
                                readonly: "",
                                type: "tel",
                                id: "comprobanteAfectado",
                                placeholder: "N° comprobante"
                              },
                              model: {
                                value: _vm.form.numero_comprobante_afectado,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "numero_comprobante_afectado",
                                    $$v
                                  )
                                },
                                expression: "form.numero_comprobante_afectado"
                              }
                            },
                            [_c("span", [_vm._v("Comprobante afectado")])]
                          ),
                          _vm._v(" "),
                          _c(
                            "modal",
                            {
                              attrs: {
                                width: "85%",
                                height: "auto",
                                scrollable: "",
                                name: "comprobantesAfectados"
                              }
                            },
                            [
                              _c("lista-comprobantes", {
                                attrs: { tipoComprobante: _vm.codigoFactura },
                                on: {
                                  selected: _vm.selectedComprobanteAfectado
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.form.id_tipo_comprobante_afectado ===
                                      "" && _vm.estado === "N",
                                  expression:
                                    "form.id_tipo_comprobante_afectado === '' && estado === 'N'"
                                }
                              ],
                              staticClass: "btn-info",
                              attrs: { type: "button" },
                              on: { click: _vm.consultarComprobantesVenta }
                            },
                            [_c("i", { staticClass: "fa fa-search" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.form.id_tipo_comprobante_afectado !==
                                      "" && _vm.estado === "N",
                                  expression:
                                    "form.id_tipo_comprobante_afectado !== '' && estado === 'N'"
                                }
                              ],
                              staticClass: "btn-danger",
                              on: { click: _vm.quitarComprobanteAfectado }
                            },
                            [_c("i", { staticClass: "fa fa-ban" })]
                          )
                        ],
                        1
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                  _c("div", { staticClass: "form-field" }, [
                    _c(
                      "div",
                      { staticClass: "datepicker-field" },
                      [
                        _c("VueCtkDateTimePicker", {
                          attrs: {
                            disabled: !_vm.editable || _vm.form.mybillbot,
                            id: "fecha_emision_comprobante_afectado",
                            locale: "es",
                            "no-label": "",
                            "only-date": "",
                            "auto-close": "",
                            "button-now-translation": "Ahora",
                            format: "YYYY-MM-DD",
                            formatted: "YYYY-MM-DD",
                            label: "Seleccione una fecha..."
                          },
                          model: {
                            value: _vm.form.fecha_emision_comprobante_afectado,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.form,
                                "fecha_emision_comprobante_afectado",
                                $$v
                              )
                            },
                            expression:
                              "form.fecha_emision_comprobante_afectado"
                          }
                        }),
                        _vm._v(" "),
                        _c("label", [
                          _vm._v("Fecha de emisión del comprobante")
                        ]),
                        _vm._v(" "),
                        _vm.errores.fecha_emision_comprobante_afectado
                          ? _c(
                              "span",
                              {
                                staticClass: "helper-text text-danger",
                                attrs: { slot: "helper" },
                                slot: "helper"
                              },
                              [
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errores
                                        .fecha_emision_comprobante_afectado[0]
                                    )
                                  )
                                ])
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-md-4" },
                  [
                    _c(
                      "input-field",
                      {
                        directives: [
                          {
                            name: "mask",
                            rawName: "v-mask",
                            value: "###-###-#########",
                            expression: "'###-###-#########'"
                          }
                        ],
                        attrs: {
                          disabled: !_vm.editable || _vm.form.mybillbot,
                          id: "numeroDocumento",
                          placeholder: "###-###-#########"
                        },
                        model: {
                          value: _vm.form.numero_comprobante,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "numero_comprobante", $$v)
                          },
                          expression: "form.numero_comprobante"
                        }
                      },
                      [
                        _vm._v(
                          "\n                Número de documento\n                "
                        ),
                        _vm.errores.numero_comprobante
                          ? _c(
                              "span",
                              {
                                staticClass: "helper-text text-danger",
                                attrs: { slot: "helper" },
                                slot: "helper"
                              },
                              [
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(_vm.errores["numero_comprobante"][0])
                                  )
                                ])
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c(
                        "input-field",
                        {
                          attrs: {
                            readonly: "",
                            id: "identificacion",
                            placeholder: "# Identificación"
                          },
                          model: {
                            value: _vm.form.identificacion_cliente,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "identificacion_cliente", $$v)
                            },
                            expression: "form.identificacion_cliente"
                          }
                        },
                        [
                          _vm._v(
                            "\n                  Identificación *\n                  "
                          ),
                          _vm.errores.id_cliente
                            ? _c(
                                "span",
                                {
                                  staticClass: "helper-text text-danger",
                                  attrs: { slot: "helper" },
                                  slot: "helper"
                                },
                                [
                                  _c("strong", [
                                    _vm._v(_vm._s(_vm.errores.id_cliente[0]))
                                  ])
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                  _c("div", { staticClass: "form-field" }, [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c(
                          "input-field",
                          {
                            attrs: {
                              readonly: "",
                              id: "cliente",
                              placeholder: "Nombre de cliente"
                            },
                            model: {
                              value: _vm.form.nombre_cliente,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "nombre_cliente", $$v)
                              },
                              expression: "form.nombre_cliente"
                            }
                          },
                          [_c("span", [_vm._v("Cliente *")])]
                        )
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                  _c("div", { staticClass: "form-field" }, [
                    _c(
                      "div",
                      { staticClass: "datepicker-field" },
                      [
                        _c("VueCtkDateTimePicker", {
                          attrs: {
                            disabled: _vm.form.mybillbot,
                            id: "fecha_emision",
                            locale: "es",
                            "no-label": "",
                            "only-date": "",
                            "auto-close": "",
                            "button-now-translation": "Ahora",
                            format: "YYYY-MM-DD",
                            formatted: "YYYY-MM-DD",
                            label: "Seleccione una fecha..."
                          },
                          model: {
                            value: _vm.form.fecha_emision,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "fecha_emision", $$v)
                            },
                            expression: "form.fecha_emision"
                          }
                        }),
                        _vm._v(" "),
                        _c("label", { attrs: { for: "fecha_emision" } }, [
                          _vm._v("Fecha de emisión (retención)")
                        ]),
                        _vm._v(" "),
                        _vm.errores.fecha_emision
                          ? _c(
                              "span",
                              {
                                staticClass: "helper-text text-danger",
                                attrs: { slot: "helper" },
                                slot: "helper"
                              },
                              [
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.errores.fecha_emision[0]))
                                ])
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                  _c(
                    "div",
                    { staticClass: "form-field" },
                    [
                      _c(
                        "input-field",
                        {
                          attrs: {
                            vMoney: "",
                            format: _vm.numero,
                            disabled: !_vm.editable || _vm.form.mybillbot,
                            placeholder: "#############",
                            id: "numero_autorizacion"
                          },
                          model: {
                            value: _vm.form.numero_autorizacion,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "numero_autorizacion", $$v)
                            },
                            expression: "form.numero_autorizacion"
                          }
                        },
                        [
                          _c("span", [_vm._v("N° Autorización")]),
                          _vm._v(" "),
                          _vm.errores.numero_autorizacion
                            ? _c(
                                "span",
                                {
                                  staticClass: "helper-text text-danger",
                                  attrs: { slot: "helper" },
                                  slot: "helper"
                                },
                                [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(_vm.errores.numero_autorizacion[0])
                                    )
                                  ])
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                  _c(
                    "div",
                    { staticClass: "form-field" },
                    [
                      _c(
                        "input-field",
                        {
                          attrs: {
                            vMoney: "",
                            format: _vm.numero,
                            disabled: !_vm.editable || _vm.form.mybillbot,
                            readonly: _vm.form.tipo === "M",
                            id: "clave_acceso",
                            placeholder: "################"
                          },
                          model: {
                            value: _vm.form.clave_acceso,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "clave_acceso", $$v)
                            },
                            expression: "form.clave_acceso"
                          }
                        },
                        [
                          _c("span", [_vm._v("Clave de acceso")]),
                          _vm._v(" "),
                          _vm.errores.clave_acceso
                            ? _c(
                                "span",
                                {
                                  staticClass: "helper-text text-danger",
                                  attrs: { slot: "helper" },
                                  slot: "helper"
                                },
                                [
                                  _c("strong", [
                                    _vm._v(_vm._s(_vm.errores.clave_acceso[0]))
                                  ])
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                  _c("div", { staticClass: "form-field" }, [
                    _c(
                      "div",
                      { staticClass: "datepicker-field" },
                      [
                        _c("date-picker", {
                          attrs: {
                            type: _vm.tipoFechaAutorizacion,
                            format: _vm.formatoFechaAutorizacion,
                            disabled: !_vm.editable || _vm.form.mybillbot,
                            id: "fecha_autorizacion",
                            lang: "es"
                          },
                          model: {
                            value: _vm.form.fecha_autorizacion,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "fecha_autorizacion", $$v)
                            },
                            expression: "form.fecha_autorizacion"
                          }
                        }),
                        _vm._v(" "),
                        _c("label", { attrs: { for: "fecha_autorizacion" } }, [
                          _vm._v("Fecha de autorización (retención)")
                        ]),
                        _vm._v(" "),
                        _vm.errores.fecha_autorizacion
                          ? _c(
                              "span",
                              {
                                staticClass: "helper-text text-danger",
                                attrs: { slot: "helper" },
                                slot: "helper"
                              },
                              [
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(_vm.errores.fecha_autorizacion[0])
                                  )
                                ])
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ])
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mt-3" },
            [
              _c("tabla-detalle-retencion", {
                attrs: {
                  venta: "",
                  disabled: !_vm.editable || _vm.form.mybillbot,
                  codigoIva: _vm.codigoIva,
                  codigoIsd: _vm.codigoIsd,
                  codigoRenta: _vm.codigoRenta,
                  baseImponibleIsd: _vm.baseImponibleIsd,
                  baseImponibleRenta: _vm.baseImponibleRenta,
                  baseImponibleIva: _vm.baseImponibleIva,
                  impuestos: _vm.impuestos,
                  errores: _vm.errores,
                  fechaEmision: _vm.form.fecha_emision
                },
                on: { input: _vm.inputDetalleRetencion },
                model: {
                  value: _vm.form.detalles,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "detalles", $$v)
                  },
                  expression: "form.detalles"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "row mt-3" }, [
            _c("div", { staticClass: "col-xs-12 col-md-6" }, [
              _c("div", { staticClass: "card" }, [
                _vm._m(1),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "card__content" },
                  [
                    _c("tabla-informacion-adicional", {
                      attrs: {
                        disabled: !_vm.editable || _vm.form.mybillbot,
                        errores: _vm.errores
                      },
                      model: {
                        value: _vm.form.detallesAdicionales,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "detallesAdicionales", $$v)
                        },
                        expression: "form.detallesAdicionales"
                      }
                    })
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12 col-md-6" }, [
              _c("div", { staticClass: "card" }, [
                _vm._m(2),
                _vm._v(" "),
                _c("div", { staticClass: "card__content" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-xs-12 col-md-6" }, [
                      _c(
                        "div",
                        { staticClass: "form-field" },
                        [
                          _c(
                            "input-field",
                            {
                              attrs: {
                                vMoney: "",
                                format: _vm.money,
                                value: _vm.isd,
                                readonly: "",
                                placeholder: "$ ##.##",
                                id: "totalISD"
                              }
                            },
                            [_c("span", [_vm._v("Total ISD")])]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-field" },
                        [
                          _c(
                            "input-field",
                            {
                              attrs: {
                                vMoney: "",
                                format: _vm.money,
                                value: _vm.iva,
                                readonly: "",
                                placeholder: "$ ##.##",
                                id: "totalIva"
                              }
                            },
                            [_c("span", [_vm._v("Total IVA")])]
                          )
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xs-12 col-md-6" }, [
                      _c(
                        "div",
                        { staticClass: "form-field" },
                        [
                          _c(
                            "input-field",
                            {
                              attrs: {
                                vMoney: "",
                                format: _vm.money,
                                value: _vm.renta,
                                readonly: "",
                                placeholder: "$ ##.##",
                                id: "totalRenta"
                              }
                            },
                            [_c("span", [_vm._v("Total Renta")])]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-field" },
                        [
                          _c(
                            "input-field",
                            {
                              attrs: {
                                vMoney: "",
                                format: _vm.money,
                                value: _vm.total,
                                readonly: "",
                                placeholder: "$ ##.##",
                                id: "totalRetenido"
                              }
                            },
                            [_c("span", [_vm._v("Total Retenido")])]
                          )
                        ],
                        1
                      )
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "layout__main-buttons" }, [
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card__content" }, [
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.form.mybillbot,
                      expression: "!form.mybillbot"
                    }
                  ],
                  staticClass: "btn-success",
                  attrs: {
                    disabled:
                      (_vm.estado === "N" && !_vm.permiteCrearRetencion) ||
                      (_vm.estado !== "N" && !_vm.permiteEditarRetencion),
                    type: "button"
                  },
                  on: { click: _vm.guardarComprobante }
                },
                [
                  _c("i", { staticClass: "fa fa-save" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Guardar")])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn-light btn--text",
                  attrs: {
                    disabled: !_vm.permiteCrearRetencion,
                    type: "button"
                  },
                  on: { click: _vm.nuevoComprobante }
                },
                [
                  _c("i", { staticClass: "fa fa-plus" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Nuevo")])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.estado !== "N" && _vm.anulado === "N",
                      expression: "estado !== 'N' && anulado === 'N'"
                    }
                  ],
                  staticClass: "btn-danger btn--text",
                  attrs: {
                    disabled: !_vm.permiteAnularRetencion,
                    type: "button"
                  },
                  on: { click: _vm.anularComprobante }
                },
                [
                  _c("i", { staticClass: "fa fa-ban" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Anular")])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.estado !== "N",
                      expression: "estado !== 'N'"
                    }
                  ],
                  staticClass: "btn-success btn--text",
                  attrs: { type: "button" },
                  on: { click: _vm.imprimirComprobante }
                },
                [
                  _c("i", { staticClass: "fa fa-print" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Imprimir")])
                ]
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            width: "70%",
            name: "coincidenciaComprobantes",
            height: "auto",
            scrollable: ""
          }
        },
        [
          _c("coincidencia-comprobantes", {
            attrs: { comprobantes: _vm.comprobantesConsultados },
            on: {
              seleccionar: _vm.seleccionarComprobanteAfectado,
              cerrar: function($event) {
                return _vm.$modal.hide("coincidenciaComprobantes")
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Información de la retención")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Detalles adicionales")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Totales")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-88a110a4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-88a110a4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/compras/Retencion.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-88a110a4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/compras/Retencion.vue
// module chunks = 0